// @flow

import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '../types';

const commonSelector = (state: RootState) => state.common;

export const jwtSelector = createSelector(commonSelector, common => common.jwt);

export const hasScannedIdSelector = createSelector(
  commonSelector,
  common => (common.identityScan && !!Object.keys(common.identityScan).length) || false,
);

export const hasJwtSelector = createSelector(
  commonSelector,
  common => !!common.jwt && !!common.jwtExpirationTime,
);
